import { NotFound, buildRoutes } from '@phishtool/ui';
import commonHydrate from '~server/hydrate/common';
import notFoundHydrate from '~server/hydrate/not-found';
import pages from '../conf/pages';
export default (siteStructure) => {
    const siteStructureRoutes = buildRoutes({
        structure: siteStructure,
        hydrate: commonHydrate,
        pages,
    });
    const routes = [
        ...siteStructureRoutes,
        {
            path: '*',
            component: NotFound,
            hydrate: notFoundHydrate,
        },
    ];
    return routes;
};
